// /**
//  * Created by zhouyiyang on 2018/10/22.
//  * tea log sdk config
//  */
// dev && ppe 环境关闭调试日志
import { isBp } from 'Src/util/tool.js'
const defaultGLOBAL = {}
const GLOBAL_VAR = window.GLOBAL_VAR ? window.GLOBAL_VAR : defaultGLOBAL
const isProdEnv = !((GLOBAL_VAR?.fe_config_env && ['test', 'abtest', 'development'].indexOf(GLOBAL_VAR?.fe_config_env) > -1) ||
  (GLOBAL_VAR?.template_config_key && GLOBAL_VAR?.template_config_key?.indexOf('ppe') > -1))

const dataRangersWhiteList = ['4645318181', '1634672144186371'].indexOf(window.GLOBAL_VAR?.advertiser?.id) > -1;

(function (i, s, o, g, r, a, m) {
  i['LogAnalyticsObject'] = r
  i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments)
  }
  i[r].l = +new Date()
  a = s.createElement(o)
  m = s.getElementsByTagName(o)[0]
  a.async = 1
  a.src = g
  m.parentNode.insertBefore(a, m)
})(window, document, 'script', dataRangersWhiteList ? 'https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/5.0/collect-rangers-v5.0.0.js' : 'https://lf3-cdn-tos.bytescm.com/obj/static/log-sdk/collect/5.0/collect.js', 'teaEvent')

window.teaEvent('init', {
  app_id: dataRangersWhiteList ? 175950 : 1192,
  channel: 'cn',
  autotrack: true,
  log: !isProdEnv
})
// 初始化设备信息
const deviceInfo = getUaInfo()
// 获取信息信息
function getUaInfo () {
  var ua = navigator.userAgent
  var isWindowsPhone = /(?:Windows Phone)/.test(ua)
  var isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
  var isAndroid = /(?:Android)/.test(ua)
  var isFireFox = /(?:Firefox)/.test(ua)
  var isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
  var isPhone = /(?:iPhone)/.test(ua) && !isTablet
  var isPc = !isPhone && !isAndroid && !isSymbian && !isTablet
  var deviceType = ''
  if (isPc) {
    deviceType = 'pc'
  } else if (isTablet) {
    deviceType = 'pad'
  } else if (isPhone) {
    deviceType = 'ios'
  } else {
    deviceType = 'android'
  }
  return {
    deviceType: deviceType,
    userAgent: ua
  }
}
window.teaEvent('config', {
  user_unique_id: isBp() ? GLOBAL_VAR?.coreUser?.id : GLOBAL_VAR?.advertiser?.id,
  evtParams: { // 设置共有的事件属性
    bp_device_id: window.deviceId || '',
    device_type: deviceInfo?.deviceType || '',
    user_agent: deviceInfo.userAgent || '',
    possess_from: GLOBAL_VAR?.possessor_origin_app_key || ''
  },
  core_user_id: GLOBAL_VAR?.coreUser?.id
})

window.teaEvent('start')

pageEnteredVariableTeaEvent()

/**
 * tea多实例
 * @param name
 * @param initParams
 * @param appId
 */
export function teaInstanceInit ({ name, initParams, appId }) {
  window.teaEvent(`${name}init`, {
    app_id: appId,
    channel: 'cn',
    log: process.env.NODE_ENV === 'development' // 开启调试日志
  })
  window.teaEvent(`${name}config`, initParams || {})
  window.teaEvent(`${name}send`)
}

window.promotionTeaEvent = (eventName, paramCallback, type) => {
  try {
    console.log(paramCallback())
    window.teaEventV1(eventName, () => {
      return {
        ...paramCallback()
      }
    }, type)
  } catch (error) {
    console.error(error)
  }
}

export function pageEnteredVariableTeaEvent () {
  window.teaEvent('page_entered_variable', {
    'request_url': window.location.href,
    'GLOBAL_VAR_user_sales': GLOBAL_VAR?.sales || '',
    'GLOBAL_VAR_user_jobbed': GLOBAL_VAR?.user_jobbed || '',
    'GLOBAL_VAR_staff_sequence': GLOBAL_VAR?.staff_sequence || '',
    'GLOBAL_VAR_customer_type': GLOBAL_VAR?.customerType || '',
    'GLOBAL_VAR_adv_search_tag': GLOBAL_VAR?.adv_search_tag || '',
    'GLOBAL_VAR_adv_feed_tag': GLOBAL_VAR?.adv_feed_tag || '',
    'GLOBAL_VAR_advertiser_name': GLOBAL_VAR?.advertiser?.name || '',
    'GLOBAL_VAR_advertiser_role': GLOBAL_VAR?.advertiser?.role || '',
    'GLOBAL_VAR_advertiser_first_industry': GLOBAL_VAR?.advertiser?.first_industry || '',
    'GLOBAL_VAR_advertiser_industry': GLOBAL_VAR?.advertiser?.industry || '',
    'GLOBAL_VAR_staff_id': GLOBAL_VAR?.staff?.id || '',
    'GLOBAL_VAR_user_role': GLOBAL_VAR?.isAdUser?.role || '',
    'GLOBAL_VAR_is_admin': GLOBAL_VAR?.isAdmin || '',
    'GLOBAL_VAR_core_user_id': GLOBAL_VAR?.coreUser?.id || ''
  })
}

window.reporterTeaEvent = (eventName, paramCallback, type) => {
  try {
    window.teaEventV1(eventName, () => {
      return {
        ...paramCallback(),
        platform: isBp() ? 'bp' : 'ad'
      }
    }, type)
  } catch (error) {
    console.error(error)
  }
}
